import { useEffect, useState } from 'react';
import { chapterImageUrl, slokaImageUrl } from '../utils/mediaUrls';

export function useVerseArtUrl(chapterNumber, slokaNumber) {
  const chapterUrl = chapterNumber != null ? chapterImageUrl(chapterNumber) : null;
  const slokaUrl =
    chapterNumber != null && slokaNumber != null
      ? slokaImageUrl(chapterNumber, slokaNumber)
      : null;

  const [url, setUrl] = useState(slokaUrl || chapterUrl);

  useEffect(() => {
    if (!chapterUrl) {
      setUrl(null);
      return undefined;
    }

    if (!slokaUrl) {
      setUrl(chapterUrl);
      return undefined;
    }

    const img = new Image();
    img.onload = () => setUrl(slokaUrl);
    img.onerror = () => setUrl(chapterUrl);
    img.src = slokaUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [chapterUrl, slokaUrl]);

  return url;
}
